import { THERMAL_HEATMAP_SUBSYSTEM_PLACEMENTS } from "../components/visualization/thermalHeatmapSubsystemConfig";
import type { SubsystemDeck } from "../../../../../../Missions/Satellites/SatelliteProfile/SatelliteDesigner/ThermalDesigner/types/subsystems";
import { DECK_TO_NODE_PREFIX } from "../../../../../../Missions/Satellites/SatelliteProfile/SatelliteDesigner/ThermalDesigner/types/subsystems";

export type { SubsystemDeck };

export interface SubsystemInDeck {
  label: string;
  nodeId: string;
  deck: SubsystemDeck;
}

/** Converts 0-based nodeId to 1-based thermal node key (e.g., "1-2" -> "PX_N3") */
export const getSubsystemNodeKey = (nodeId: string, deck: SubsystemDeck): string => {
  const deckPrefix = DECK_TO_NODE_PREFIX[deck];
  const nodeNumber = parseInt(nodeId.split("-").pop() || "0", 10);
  return `${deckPrefix}_N${nodeNumber + 1}`;
};

export const getSubsystemsByDeck = (): Record<SubsystemDeck, SubsystemInDeck[]> => {
  const map: Record<SubsystemDeck, SubsystemInDeck[]> = {
    "deck-0": [],
    "deck-1": [],
    "deck-2": [],
    "deck-3": [],
  };

  THERMAL_HEATMAP_SUBSYSTEM_PLACEMENTS.forEach((placement) => {
    map[placement.deck].push({
      label: placement.label,
      nodeId: placement.nodeId,
      deck: placement.deck,
    });
  });

  return map;
};

export const SUBSYSTEMS_BY_DECK = getSubsystemsByDeck();
